import React from 'react';

export const PartyCategoryIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_155)">
            <path d="M1.71833 5.83333C2.12833 2.545 4.93333 0 8.33333 0H11.6667C15.0675 0 17.8683 2.54833 18.2767 5.83917C16.4625 5.87 15 7.345 15 9.16667V10.8333H5V9.16667C5 7.34333 3.535 5.86167 1.71833 5.83333ZM18.0533 7.5225C17.2342 7.65583 16.6667 8.425 16.6667 9.25583V15.8333C16.6667 16.2933 16.2933 16.6667 15.8333 16.6667C15.3733 16.6667 15 16.2933 15 15.8333V12.5H5V15.8333C5 16.2933 4.62667 16.6667 4.16667 16.6667C3.70667 16.6667 3.33333 16.2933 3.33333 15.8333V9.25583C3.33333 8.42583 2.76583 7.65583 1.94667 7.5225C0.9025 7.3525 0 8.15417 0 9.16667V14.5833C0 15.8833 0.6625 17.0275 1.66667 17.7V19.1667C1.66667 19.6267 2.04 20 2.5 20C2.96 20 3.33333 19.6267 3.33333 19.1667V18.2917C3.47167 18.3075 3.6075 18.3333 3.75 18.3333H16.25C16.3925 18.3333 16.5283 18.3067 16.6667 18.2917V19.1667C16.6667 19.6267 17.04 20 17.5 20C17.96 20 18.3333 19.6267 18.3333 19.1667V17.7C19.3375 17.0275 20 15.8833 20 14.5833V9.16667C20 8.15417 19.0975 7.35333 18.0533 7.5225Z" fill="white" fill-opacity="0.94"/>
            </g>
            <defs>
            <clipPath id="clip0_1_155">
            <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
        </svg>

    )
}